function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { letterSpacings } from '../../../../theme/foundations/typography';
var sourceSansProFont = "'Source Sans Pro', sans-serif";
export var fonts = {
  heading: sourceSansProFont,
  body: sourceSansProFont
};
export var fontWeights = {
  normal: 400,
  semibold: 600,
  bold: 700
};
export var textSizes = {
  lg: {
    fontSize: 'md',
    lineHeight: 'base'
  },
  sm: {
    fontSize: 'sm',
    lineHeight: 'short'
  },
  xs: {
    fontSize: 'xs',
    lineHeight: 'normal'
  }
};
export var headingSizes = {
  xl: {
    fontSize: '2xl',
    lineHeight: 'taller',
    fontWeight: fontWeights.bold
  },
  lg: {
    fontSize: 'xl',
    lineHeight: 'tall',
    fontWeight: fontWeights.semibold
  },
  mdlg: {
    fontSize: 'mdlg',
    lineHeight: '2rem',
    fontWeight: fontWeights.semibold
  },
  md: {
    fontSize: 'lg',
    lineHeight: 'base',
    fontWeight: fontWeights.semibold
  },
  sm: {
    fontSize: 'md',
    lineHeight: 'base',
    fontWeight: fontWeights.bold
  }
};
export var textStyles = {
  'heading-xl': _objectSpread(_objectSpread({}, headingSizes['xl']), {}, {
    letterSpacing: letterSpacings.normal
  }),
  'heading-lg': _objectSpread(_objectSpread({}, headingSizes['lg']), {}, {
    letterSpacing: letterSpacings.normal
  }),
  'heading-mdlg': _objectSpread(_objectSpread({}, headingSizes['mdlg']), {}, {
    letterSpacing: letterSpacings.normal
  }),
  'heading-md': _objectSpread(_objectSpread({}, headingSizes['md']), {}, {
    letterSpacing: letterSpacings.normal
  }),
  'heading-sm': _objectSpread(_objectSpread({}, headingSizes['sm']), {}, {
    letterSpacing: letterSpacings.normal
  }),
  'lead-lg-bold': _objectSpread(_objectSpread({}, textSizes['lg']), {}, {
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacings.normal
  }),
  'lead-lg': _objectSpread(_objectSpread({}, textSizes['lg']), {}, {
    fontWeight: fontWeights.semibold,
    letterSpacing: letterSpacings.normal
  }),
  'lead-sm': _objectSpread(_objectSpread({}, textSizes['sm']), {}, {
    fontWeight: fontWeights.semibold,
    letterSpacing: letterSpacings.normal
  }),
  'body-lg': _objectSpread(_objectSpread({}, textSizes['lg']), {}, {
    fontWeight: fontWeights.normal,
    letterSpacing: letterSpacings.normal
  }),
  'body-sm': _objectSpread(_objectSpread({}, textSizes['sm']), {}, {
    fontWeight: fontWeights.normal,
    letterSpacing: letterSpacings.normal
  }),
  'body-xs': _objectSpread(_objectSpread({}, textSizes['xs']), {}, {
    fontWeight: fontWeights.normal,
    letterSpacing: letterSpacings.normal
  })
};
var typography = {
  fonts,
  textStyles,
  headingSizes
};
export default typography;